<template>
  <div
    class="flex justify-start gap-2 overflow-hidden rounded-lg py-3.5"
    :class="wrap ? 'items-start' : 'items-center'"
  >
    <div class="relative size-5 shrink-0 overflow-hidden">
      <img
        alt=""
        class="block size-full max-w-none"
        :src="phoneIcon"
        aria-hidden="true"
      >
    </div>
    <div
      class="flex flex-col justify-center leading-none"
      :class="wrap ? 'whitespace-normal' : 'whitespace-nowrap'"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
import phoneIcon from '@/images/components/phone.svg';

defineProps({
  wrap: {
    type: Boolean,
    default: false,
  },
});
</script>
